import BusinessCategoryModal from './BusinessCategoryModal';

export default BusinessCategoryModal;
